export default __webpack_public_path__ + "static/banner-the-all-in-one-things-to-look-out-for-when-consolidating-debt-94f2637a0b1605ed873b425c8569a1a9.webp";